import React, {useMemo} from "react";
import {useTranslation} from "react-i18next";
import {parseProbe} from "../parsers";
import DeviceDefaultContent from "./DeviceDefaultContent";
import {createKeysAndLabels} from "./utils";
import {getAlias} from "../../../../utils/DevicesUtils";

const ProbeContent = (props) => {
    const {t} = useTranslation();

    const {keys, labels} = useMemo(() => {
        return createKeysAndLabels(
            {
                key: "textTempMean",
                label: t("averageTemperature"),
            },
            {
                key: "textTempMin",
                label: t("minimumTemperature"),
            },
            {
                key: "textTempMax",
                label: t("maximumTemperature"),
            }
        );
    }, [t]);

    const name = useMemo(() => {
        const alias = getAlias(props.device);
        let siloName = `${t("farms.tabs.mapTab.types.PROBE")}`;
        const name = [props.device.Name];
        if (alias !== "") name.push(alias);
        return `${siloName} (${name.join(" | ")})`;
    }, [t, props.device]);

    return (
        <DeviceDefaultContent
            {...props}
            parseDataFn={parseProbe}
            name={name}
            paramKeys={keys}
            paramLabel={labels}
        />
    );
};

export default React.memo(ProbeContent);
